import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { InputBox } from "../../components";
import { ApiHelper, DepartmentInterface, ScreenInterface } from "../../helpers";

interface Props {
  department: DepartmentInterface;
  onDone: () => void
}

export const DepartmentEdit: React.FC<Props> = props => {

  const [department, setDepartment] = React.useState<DepartmentInterface>(null);
  const [screens, setScreens] = React.useState<ScreenInterface[]>([]);

  const init = () => {
    setDepartment(props.department);
    setScreens([{}]);
    if (props.department?.id > 0) ApiHelper.get<ScreenInterface[]>("/screens/department/" + props.department.id).then(data => setScreens(data || []));
  }

  React.useEffect(init, [props.department]);


  const handleChange = (e: any) => {
    let d: DepartmentInterface = { ...department };
    const val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "departmentName": d.name = val; break;
    }
    setDepartment(d);
  }

  const handleSave = () => { ApiHelper.post("/departments", [department]).then(() => { props.onDone() }); }

  const handleCancel = () => { props.onDone(); }

  const handleDelete = () => { ApiHelper.delete("/departments/" + department.id).then(() => { props.onDone() }); }

  const getDeleteFunction = () => {
    if (department?.id > 0 && screens.length === 0) return handleDelete;
    else return null;
  }

  return <InputBox headerText="Departments" headerIcon="fas fa-users" saveFunction={handleSave} cancelFunction={handleCancel} deleteFunction={getDeleteFunction()} deleteText="Delete department" >
    <FormGroup className="mb-3">
      <FormLabel>Name</FormLabel>
      <FormControl id="departmentName" value={department?.name} onChange={handleChange} />
    </FormGroup>
  </InputBox>

};